export const joinMaps = (aggregate, emptyVal) => (acc, map) => {
    for (const [key, b] of map) {
        acc.set(key, aggregate(acc.get(key) || emptyVal, b));
    }
    return acc;
};
//# sourceMappingURL=joinMaps.js.map